import React, { useState } from 'react';
import { GoogleMap, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';

const containerStyle = {
  width: '100%',
  height: '550px'
};

const center = {
 lat: 33.450701, lng: 126.570667
};

const MapGoogle = ({ points }) => {
  const [selected, setSelected] = useState(null); // 선택된 마커 상태

  var mapInfos = [];
  points.forEach((point) => {
    const xy = point.xy;
    const [lngX, latY] = xy.split(",").map(Number);
    let p = {
      lat: latY,
      lng: lngX
    };

    let mapInfo = {
      position: p,
      info: getInfoWindowContents(point.groups)
    };

    mapInfos.push(mapInfo);
  });

  const onSelect = (marker) => {
    setSelected(marker);
  };

  function getInfoWindowContents(groups) {
    let contents =
      '<div class="map-modal" style="background-color: transparent;">';
    contents += `<div class="h-stack group">
                        <div class="w70 size15"><strong>주&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;소</strong></div>
                        <div class="size14"><b>${groups[0].address}</b></div>
                    </div>`;
    groups.some((v, idx) => {
      if (groups.length === 1) {
        contents += `<br/>
                            <div class="h-stack group">
                                <div class="w80 size15"><strong>프로젝트</strong></div>
                                <div class="size14"><a href="#" onclick="saveProjectInfo('${v.name}', '${v.id}')" >${
          v.name
        }</div>
                            </div>`;
      } else {
        contents += `<br/>
                            <div class="h-stack group">
                                <div class="w80 size15"><strong>프로젝트${
                                  idx + 1
                                }</strong></div>
                                <div class="size14">${v.name}</div>
                            </div>`;
      }
    });
    contents += "</div>";
    return contents;
  }

  return (
    <LoadScript
      googleMapsApiKey="AIzaSyAfDa7Gdb6TEDUkxdXlAQR-LnyBVbNN6cA" // 여기에 발급받은 API 키를 입력하세요.
    >
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={10}
      >
        {/* 마커 추가 */}
         {mapInfos.map((mapInfo, index) => (

         
          <Marker 
            key={index}
            position={mapInfo.position} 
            onClick={() => onSelect(mapInfo)} 
          />
        ))}

        {/* InfoWindow 추가 */}
        {selected && (
          <InfoWindow
            position={selected.position}
            onCloseClick={() => setSelected(null)}
          >
           <div dangerouslySetInnerHTML={{ __html: selected.info }} /> 
          </InfoWindow>
        )}
      </GoogleMap>
    </LoadScript>
  );
};

export default MapGoogle